import React from 'react'

const Banner = (props) => (
    <section id="banner" className="major">
        <div className="inner">
            <header className="major">
                <h1>Hi, my name is Umair</h1>
            </header>
            <div className="content">
                <h3>Web Developer UI - JAMStack<br />
                Machine Learning AI Services</h3>
                <ul className="actions">
                    <li><a href="#two" className="button next scrolly">About Me</a></li>
                </ul>
            </div>
        </div>
    </section>
)

export default Banner
